/// <amd-module name="SuiteCommerce.Blog.SuggestionsList.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.SuggestionsList.Model", ["require", "exports", "Backbone", "SuiteCommerce.Blog.Post.Collection"], function (require, exports, Backbone_1, Post_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var SuggestionsListModel = /** @class */ (function (_super) {
        __extends(SuggestionsListModel, _super);
        function SuggestionsListModel(options) {
            return _super.call(this, options) || this;
        }
        Object.defineProperty(SuggestionsListModel.prototype, "title", {
            get: function () {
                return this.get('title');
            },
            set: function (title) {
                this.set('title', title);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SuggestionsListModel.prototype, "suggestionMessage", {
            get: function () {
                return this.get('suggestionMessage');
            },
            set: function (suggestionMessage) {
                this.set('suggestionMessage', suggestionMessage);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SuggestionsListModel.prototype, "searchOptions", {
            get: function () {
                return this.get('searchOptions');
            },
            set: function (searchOptions) {
                this.set('searchOptions', searchOptions);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SuggestionsListModel.prototype, "suggestionList", {
            get: function () {
                if (!this.get('suggestionList')) {
                    this.set('suggestionList', new Post_Collection_1.PostCollection());
                }
                return this.get('suggestionList');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SuggestionsListModel.prototype, "quantityOfSuggestions", {
            get: function () {
                return this.get('quantityOfSuggestions');
            },
            set: function (quantityOfSuggestions) {
                this.set('quantityOfSuggestions', quantityOfSuggestions);
            },
            enumerable: true,
            configurable: true
        });
        return SuggestionsListModel;
    }(Backbone_1.Model));
    exports.SuggestionsListModel = SuggestionsListModel;
});
